<template>
  <div class="block">
    <div class="flex items-center justify-center gap-2">
      <Checkbox v-model='isRecurringTask' binary size="large" id="rec_box"/>
      <label for="rec_box" class="flex items-center justify-center cursor-pointer" id="lbl_recBox2">
        {{ $t('KssRecurringTaskComponent.isRecurringTask') }}
      </label>
    </div>
    <div v-if="isRecurringTask" class="w-full py-4 px-4 my-2" id="drop_event">
      <div class="flex items-center justify-center">
        <div>
          <Select v-model="type" :options="recTaskDropdown" optionLabel="name"
            optionValue ="value" class="w-56 bg-[var(--color-light)] h-10"
            name="eventtime" id="select_event"/>
        </div>
      </div>
      <div v-if="type === 'custom'" class="flex flex-wrap justify-center items-center flex-row mt-4
        gap-2" id="custom_choice">
        <label class="flex relative m-1 text-base w-fit" for="nmbr">
            {{ $t('KssRecurringTaskComponent.repeatEvery') }}
        </label>
        <InputNumber v-model="everyX" min="1" id="nmbr" inputStyle="width:50px" class="h-10"/>
        <Select v-model="subtype" :options="customDropdown" optionLabel="name"
            optionValue ="value" class="w-32 bg-[var(--color-light)] h-10"
            name="nmbrevent" id="nmbr_event"/>
      </div>
      <div v-if="type === 'monthly'" class="flex flex-wrap justify-center items-center flex-row mt-4
        gap-2" id="monthly_week_choice">
        <label class="flex relative m-1 text-base w-fit" for="week_of_month">
          {{ $t('KssRecurringTaskComponent.weekOfMonth') }}
        </label>
        <Select
          v-model="weekOfMonth"
          :options="weekOfMonthOptions"
          optionLabel="name"
          optionValue="value"
          class="w-64 bg-[var(--color-light)] h-10"
          inputId="week_of_month"
        />
      </div>
      <div v-if="type === 'daily' || (type === 'custom' && subtype === 'days')"
        class="flex items-center justify-center gap-2 mt-4">
        <Checkbox v-model="includeWeekends" binary id="include_weekends"/>
        <label for="include_weekends" class="cursor-pointer text-base">
          {{ $t('KssRecurringTaskComponent.includeWeekends') }}
        </label>
      </div>
      <div class="flex flex-col items-center justify-center gap-2 mt-4">
        <label for="series_end_date" class="text-base">
          {{ $t('KssRecurringTaskComponent.seriesEndDate') }}
        </label>
        <input
          id="series_end_date"
          type="date"
          class="h-10 px-3 rounded-lg border border-[var(--color-light-grey)] bg-[var(--color-light)]"
          :value="seriesEndDateInput"
          @input="onSeriesEndDateInput"
        />
        <button
          v-if="seriesEndDateInput"
          type="button"
          class="text-sm text-[var(--color-orange)]"
          @click="clearSeriesEndDate"
        >
          {{ $t('KssRecurringTaskComponent.clearSeriesEndDate') }}
        </button>
      </div>
      <div v-if="showWeekDays" id="seven_days"
        class="flex items-center justify-center flex-wrap mt-6">
        <label id="day" v-for="(day, index) in getDays" :key="day.rSchName" @click="selectDay(index)"
            class="flex relative m-1 text-sm w-fit">
          <div class="flex p-3 w-full rounded-lg m-0 cursor-pointer border-[1px]
                    border-[var(--color-light-grey)]"
        :class="{'text-[var(--color-orange)] border-[var(--color-orange)] bg-[var(--color-bisque)]'
                     : day.isSelected}">
            <span :class="{'font-semibold': day.isSelected}">
              {{ $t('KssRecurringTaskComponent.daysShort.' + day.rSchName) }}</span>
          </div>
        </label>
      </div>
    </div>
  </div>
</template>

<script>
import { Checkbox, InputNumber, Select } from 'primevue';
import { ref } from 'vue';

export default {
  name: 'KssRecurringTaskComponent',
  components: { Checkbox, Select, InputNumber },
  data() {
    return {
      type: this.$store.state.kss.recurringType,
      subtype: this.$store.state.kss.recurringSubtype,
      everyX: this.$store.state.kss.recurringEveryX,
      recTaskDropdown: ref([
        { name: this.$t('KssRecurringTaskComponent.daily'), value: 'daily' },
        { name: this.$t('KssRecurringTaskComponent.weekly'), value: 'weekly' },
        { name: this.$t('KssRecurringTaskComponent.monthly'), value: 'monthly' },
        { name: this.$t('KssRecurringTaskComponent.custom'), value: 'custom' },
      ]),
      customDropdown: ref([
        { name: this.$t('KssRecurringTaskComponent.days'), value: 'days' },
        { name: this.$t('KssRecurringTaskComponent.weeks'), value: 'weeks' },
      ]),
      weekOfMonthOptions: ref([
        { name: this.$t('KssRecurringTaskComponent.weekOfMonthOption1'), value: 1 },
        { name: this.$t('KssRecurringTaskComponent.weekOfMonthOption2'), value: 2 },
        { name: this.$t('KssRecurringTaskComponent.weekOfMonthOption3'), value: 3 },
        { name: this.$t('KssRecurringTaskComponent.weekOfMonthOption4'), value: 4 },
        { name: this.$t('KssRecurringTaskComponent.weekOfMonthOption5'), value: 5 },
      ]),
    };
  },
  computed: {
    isRecurringTask: {
      get() {
        return this.$store.getters.getIsRecurringTask;
      },
      set(newValue) {
        this.$store.commit('setIsRecurringTask', newValue);
      },
    },
    getDays() {
      return this.$store.getters.getRecurringDays;
    },
    showWeekDays() {
      return this.type === 'weekly'
        || this.type === 'monthly'
        || (this.type === 'custom' && this.subtype === 'weeks');
    },
    weekOfMonth: {
      get() {
        return this.$store.getters.getRecurringWeekOfMonth;
      },
      set(value) {
        this.$store.commit('setRecurringWeekOfMonth', value);
      },
    },
    includeWeekends: {
      get() {
        return this.$store.getters.getIncludeWeekends;
      },
      set(value) {
        this.$store.commit('setIncludeWeekends', value);
      },
    },
    seriesEndDateInput() {
      const d = this.$store.getters.getSeriesEndDate;
      if (!d) return '';
      const date = new Date(d);
      const y = date.getFullYear();
      const m = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${y}-${m}-${day}`;
    },
  },
  methods: {
    onSeriesEndDateInput(event) {
      const value = event?.target?.value;
      this.$store.commit('setSeriesEndDate', value || null);
    },
    clearSeriesEndDate() {
      this.$store.commit('setSeriesEndDate', null);
    },
    selectDay(index) {
      if (this.type === 'monthly') {
        this.$store.commit('selectRecurringDateMonthly', index);
      } else {
        this.$store.commit('selectRecurringDate', index);
      }
    },
  },
  watch: {
    type(value) {
      this.$store.commit('setRecurringType', value);
      this.subtype = 'days';
      this.everyX = 1;
    },
    subtype(value) {
      this.$store.commit('setRecurringSubtype', value);
    },
    everyX(value) {
      this.$store.commit('setRecurringEveryX', value);
    },
  },
  mounted() {
    this.$store.commit('initRecurringDays');
  },
};
</script>
